Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsConversationView extends Backbone.View
  className: 'ticket-details-conversation'
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_conversation"]

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @priorities = @options.priorities
    @interaction = @options.interaction
    @statsView = new Customer.Dashboard.TicketDetailsStatsView(ticket: @ticket, interaction: @interaction)
    @attributesView = new Customer.Dashboard.TicketDetailsAttributesView(
      ticket: @ticket,
      priorities: @priorities,
      ticketAttributesCollection: @options.ticketAttributesCollection
    )

  render: ->
    @$el.html(@template(ticket: @ticket))
    @$el.find('.summary-groups').html(@getGroupsView().render())
    @$el.find('.ticket-details-stats-container').html(@statsView.render().el)
    @statsView.delegateEvents()
    @renderCounters()
    @$el.find('.ticket-details-attributes-container').html(@attributesView.render().el)
    @

  getGroupsView: =>
    @groupsView ||= new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: @ticket.getGroups()
      selectedTagCodes: @ticket.getGroups()
      suggestedTags: []
      showMoreButton: true
      readOnly: true
      mode: 'ticket-summary'
      groupsInsteadOfTags: true
    )

  validateFieldsAreFilled: (fields) =>
    @attributesView.validateFieldsAreFilled(fields)

  isBeingModified: ->
    return false unless @attributesView?
    @attributesView.isBeingModified()

  renderCounters: =>
    if @ticket.isWebchat()
      @countersView = new Customer.Dashboard.TicketDetailsCountersView(ticket: @ticket) unless @countersView
      @$el.find('.ticket-details-counters-container').html(@countersView.render().el)
      @countersView.startCounting() if @ticket.getStatus() != "Closed"


  hidePrioritySpinner: ->
    @statsView.hidePrioritySpinner()

  onAttributesValidationError: (ticketAttributeErrors) =>
    @attributesView.onAttributesValidationError(ticketAttributeErrors)

  onTicketClose: =>
    @attributesView.onTicketClose()
